import React, { Component } from "react";
import addToMailchimp from "gatsby-plugin-mailchimp";

class EmailCaptureForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      submitted: false,
      success: false,
      successMessage: "Tack! :) Vi har tagit emot din adress.",
      error: false,
      errorMessage: "Adressen finns redan, eller något gick fel."
    };

    this.onTextChange = this.onTextChange.bind(this);
  }

  onTextChange(e) {
    this.setState({ email: e.target.value });
  }

  handleSubmit = event => {
    event.preventDefault();
    addToMailchimp(this.state.email).then(data => {
      if (data.result === "success") {
        this.setState({ ...this.state, success: true, error: false });
      } else {
        this.setState({ ...this.state, error: true });
      }
    });
  };

  render() {
    const { success, error, successMessage, errorMessage, email } = this.state;

    return (
      <div>
        {!success && (
          <form
            id="email-capture"
            className="EmailCaptureForm"
            onSubmit={this.handleSubmit}
            noValidate
          >
            <div className="EmailCaptureForm__field">
              <label htmlFor="af-email">E-post</label>
              <input
                id="af-email"
                className="EmailCaptureForm__input"
                type="email"
                value={email}
                onChange={this.onTextChange}
              />
              <p className="EmailCaptureForm__smalltext">
                Vi lovar att aldrig mejla dig om något annat. Vi använder
                Mailchimps E-postservice.{" "}
                <a
                  className="c-link"
                  href="https://mailchimp.com/legal/privacy/"
                >
                  Läs integritetspolicyn
                </a>{" "}
                här.
              </p>
            </div>
            <div className="EmailCaptureForm__submit">
              <input
                className="button button--accent button--round button--large"
                type="submit"
                value="Mejla mig Pyramidanalysen"
              />
            </div>
          </form>
        )}
        {success ? (
          <div className="EmailCaptureForm__alert EmailCaptureForm__alert--success">
            {successMessage}
          </div>
        ) : null}
        {error ? (
          <div className="EmailCaptureForm__alert EmailCaptureForm__alert--error">
            {errorMessage}
          </div>
        ) : null}
      </div>
    );
  }
}

export default EmailCaptureForm;



// WEBPACK FOOTER //
// ./src/components/Form.js